<template>
    <BetSlipCompact
        v-if="this.selections.length > 0"
        :coefficient="totalCoefficient"
        :stake="rawStake"
        :potentialWin="maxPotentialWin"
        :hasLiveEvents="hasLiveEvents"
        :numberOfEvents="this.selections.length"
        @expand="onExpandClick"
    />
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import StoreUtil from '@app/store/StoreUtil';
    import Modals from '@store/modules/ui/shared/modal/modals';
    import BetSlipCompact from './BetSlipCompact';

    export default {
        props: {
            betSlipNamespace: {
                type: String,
                required: true,
            },
        },
        computed: {
            ...mapGetters('data/country', {
                serverConfig: 'config',
            }),
            ...StoreUtil.mapGettersDynamic('betSlipNamespace', [
                'selections',
                'rawStake',
                'payout',
                'totalCoefficient',
            ]),
            hasLiveEvents() {
                return this.selections.some((s) => s.event.isOngoing());
            },
            maxPotentialWin() {
                return Math.min(this.payout.final, this.serverConfig.betSlip.maxWin);
            },

        },
        methods: {
            onExpandClick() {
                this.setModal({
                    code: Modals.betSlipPreview.code,
                    data: {
                        betSlipNamespace: this.betSlipNamespace,
                        hasSystems: this.hasSystems,
                    },
                });
            },
            ...mapActions('ui/modal', [
                'setModal',
            ]),
        },
        components: {
            BetSlipCompact,
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/mobile/shared/components/BetSlipCompact/BetSlipCompactContainer.vue